type LandingCopy = { title: string; freeCta: string; paid: string; once: string; free: string; outfits: string; capsule: string; bridge: string; sampleBadge: string; optional: string };
export const kibbeLandingCopy: Record<string, LandingCopy> = {
  "en": {
    "title": "Understand your Kibbe type. See what to wear.",
    "freeCta": "Get my free AI preview",
    "paid": "Full report",
    "once": "one-time",
    "free": "Free preview",
    "outfits": "6 illustrated outfits",
    "capsule": "10 capsule pieces",
    "bridge": "Explore your likely type, then put the ideas to work.",
    "sampleBadge": "Generated report sample",
    "optional": "Optional"
  },
  "es": {
    "title": "Entiende tu tipo Kibbe. Descubre qué ponerte.",
    "freeCta": "Ver mi estimación IA gratis",
    "paid": "Informe completo",
    "once": "pago único",
    "free": "Estimación gratuita",
    "outfits": "6 conjuntos ilustrados",
    "capsule": "10 prendas cápsula",
    "bridge": "Explora tu tipo probable y aplica las ideas.",
    "sampleBadge": "Ejemplo de informe generado",
    "optional": "Opcional"
  },
  "fr": {
    "title": "Comprenez votre type Kibbe. Trouvez vos tenues.",
    "freeCta": "Voir mon aperçu IA gratuit",
    "paid": "Rapport complet",
    "once": "paiement unique",
    "free": "Aperçu gratuit",
    "outfits": "6 tenues illustrées",
    "capsule": "10 pièces capsule",
    "bridge": "Explorez votre type probable et passez aux idées concrètes.",
    "sampleBadge": "Exemple de rapport généré",
    "optional": "Facultatif"
  },
  "de": {
    "title": "Verstehe deinen Kibbe-Typ. Entdecke passende Outfits.",
    "freeCta": "Meine kostenlose KI-Vorschau",
    "paid": "Vollständiger Bericht",
    "once": "einmalig",
    "free": "Kostenlose Vorschau",
    "outfits": "6 Outfit-Illustrationen",
    "capsule": "10 Capsule-Teile",
    "bridge": "Entdecke deinen wahrscheinlichen Typ und probiere die Ideen aus.",
    "sampleBadge": "Generiertes Berichtsbeispiel",
    "optional": "Optional"
  },
  "it": {
    "title": "Comprendi il tuo tipo Kibbe. Scopri cosa indossare.",
    "freeCta": "La mia anteprima IA gratuita",
    "paid": "Report completo",
    "once": "pagamento unico",
    "free": "Anteprima gratuita",
    "outfits": "6 outfit illustrati",
    "capsule": "10 capi capsule",
    "bridge": "Esplora il tuo tipo probabile e metti in pratica le idee.",
    "sampleBadge": "Esempio di report generato",
    "optional": "Facoltativo"
  },
  "pt": {
    "title": "Entenda seu tipo Kibbe. Descubra o que vestir.",
    "freeCta": "Ver minha prévia de IA grátis",
    "paid": "Relatório completo",
    "once": "pagamento único",
    "free": "Prévia gratuita",
    "outfits": "6 looks ilustrados",
    "capsule": "10 peças cápsula",
    "bridge": "Explore seu tipo provável e coloque as ideias em prática.",
    "sampleBadge": "Exemplo de relatório gerado",
    "optional": "Opcional"
  },
  "pl": {
    "title": "Poznaj swój typ Kibbe. Odkryj, co nosić.",
    "freeCta": "Moja bezpłatna analiza wstępna AI",
    "paid": "Pełny raport",
    "once": "jednorazowo",
    "free": "Bezpłatny podgląd",
    "outfits": "6 ilustracji stylizacji",
    "capsule": "10 elementów kapsuły",
    "bridge": "Poznaj swój prawdopodobny typ i wypróbuj pomysły.",
    "sampleBadge": "Przykład wygenerowanego raportu",
    "optional": "Opcjonalnie"
  },
  "ru": {
    "title": "Поймите свой типаж Kibbe. Узнайте, что носить.",
    "freeCta": "Бесплатная предварительная оценка ИИ",
    "paid": "Полный отчёт",
    "once": "один раз",
    "free": "Бесплатная оценка",
    "outfits": "6 иллюстраций образов",
    "capsule": "10 вещей капсулы",
    "bridge": "Изучите вероятный тип и попробуйте идеи на практике.",
    "sampleBadge": "Пример сгенерированного отчёта",
    "optional": "По желанию"
  },
  "ko": {
    "title": "나의 Kibbe 유형을 이해하고 코디를 찾아보세요.",
    "freeCta": "무료 AI 미리보기 받기",
    "paid": "전체 보고서",
    "once": "일회성",
    "free": "무료 미리보기",
    "outfits": "코디 일러스트 6개",
    "capsule": "캡슐 아이템 10개",
    "bridge": "가능성 높은 유형을 살펴보고 스타일 아이디어를 시도하세요.",
    "sampleBadge": "생성된 보고서 샘플",
    "optional": "선택 사항"
  },
  "hi": {
    "title": "अपना Kibbe प्रकार समझें। जानें क्या पहनें।",
    "freeCta": "मेरा मुफ़्त AI पूर्वावलोकन",
    "paid": "पूरी रिपोर्ट",
    "once": "एक बार",
    "free": "मुफ़्त पूर्वावलोकन",
    "outfits": "6 पोशाक चित्र",
    "capsule": "10 कैप्सूल वस्तुएँ",
    "bridge": "अपने संभावित प्रकार को समझें और सुझाव आज़माएँ।",
    "sampleBadge": "तैयार की गई नमूना रिपोर्ट",
    "optional": "वैकल्पिक"
  },
  "id": {
    "title": "Pahami tipe Kibbe Anda. Temukan busana yang cocok.",
    "freeCta": "Lihat pratinjau AI gratis saya",
    "paid": "Laporan lengkap",
    "once": "sekali bayar",
    "free": "Pratinjau gratis",
    "outfits": "6 ilustrasi busana",
    "capsule": "10 item kapsul",
    "bridge": "Jelajahi tipe yang mungkin cocok dan coba ide-idenya.",
    "sampleBadge": "Contoh laporan yang dihasilkan",
    "optional": "Opsional"
  }
};
